'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonPropTypes = {
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large'])
};

exports.default = commonPropTypes;